export function ToothMark({ className = "h-9 w-9", stroke = "#1D769A" }) {
    return (
        <svg
            viewBox="0 0 120 140"
            fill="none"
            className={className}
            aria-hidden="true"
        >
            <path
                d="M22 74 C18 42 32 20 50 19 C60 18 65 28 73 29 C81 28 86 18 96 19 C114 20 126 44 120 78 C117 100 111 118 104 126 C99 131 94 127 93 117 C91 101 86 88 73 88 C60 88 55 101 53 117 C52 127 47 131 42 126 C34 117 25 96 22 74 Z"
                stroke={stroke}
                strokeWidth="7"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default function Logo({ light = false, compact = false }) {
    return (
        <img
            src={light ? "/images/logo-light.png" : "/images/logo.png"}
            alt="dott. mario massironi — odontoiatria e protesi dentaria"
            data-testid="brand-logo"
            className={`w-auto object-contain ${
                compact ? "h-14" : "h-16 sm:h-20"
            }`}
        />
    );
}
